var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91 17.1814C3.72 17.1814 3.53 17.1114 3.38 16.9614C2.01 15.5814 1.25 13.7614 1.25 11.8314C1.25 7.82141 4.5 4.56139 8.5 4.56139L14.57 4.58141L13.48 3.54137C13.18 3.25137 13.17 2.78137 13.46 2.48137C13.75 2.18137 14.22 2.17141 14.52 2.46141L16.96 4.80138C17.18 5.01138 17.25 5.34139 17.14 5.62139C17.03 5.90139 16.75 6.09142 16.44 6.09142L8.49001 6.0714C5.32001 6.0714 2.74001 8.66142 2.74001 11.8414C2.74001 13.3714 3.33999 14.8214 4.42999 15.9114C4.71999 16.2014 4.71999 16.6814 4.42999 16.9714C4.28999 17.1114 4.1 17.1814 3.91 17.1814Z",
    fill: "#14477D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 21.7514C9.8099 21.7514 9.6299 21.6814 9.4799 21.5414L7.0399 19.2014C6.8199 18.9914 6.7499 18.6614 6.8599 18.3814C6.9699 18.1014 7.2499 17.9114 7.5599 17.9114L15.5099 17.9314C18.6799 17.9314 21.2599 15.3414 21.2599 12.1614C21.2599 10.6314 20.6599 9.18146 19.5699 8.09146C19.2799 7.80146 19.2799 7.32147 19.5699 7.03147C19.8599 6.74146 20.3399 6.74146 20.6299 7.03147C21.9999 8.41146 22.7599 10.2314 22.7599 12.1614C22.7599 16.1714 19.5099 19.4314 15.5099 19.4314L9.4399 19.4114L10.5299 20.4514C10.8299 20.7414 10.8399 21.2114 10.5499 21.5114C10.3899 21.6714 10.1999 21.7514 9.9999 21.7514Z",
    fill: "#14477D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.7515H15C15.41 12.7515 15.75 12.4115 15.75 12.0015C15.75 11.5915 15.41 11.2515 15 11.2515H9C8.59 11.2515 8.25 11.5915 8.25 12.0015C8.25 12.4115 8.59 12.7515 9 12.7515Z",
    fill: "#14477D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrIcon);
export default __webpack_public_path__ + "static/media/DRIcon.d27a88580e75b7669dac6fdb600b6761.svg";
export { ForwardRef as ReactComponent };